import { IconProp } from '@fortawesome/fontawesome-svg-core'
import React from 'react'

import { Schema, Size } from '@/types'

import Button from '../../../Button/Button'
import { FormContext, withForm } from '../../FormContext'

interface Props {
	children?: React.ReactNode,
	className?: string,
	disabled?: boolean,
	form?: FormContext,
	icon?: IconProp,
	schema?: Schema,
	size?: Size,
	testId?: string
}

class Submit extends React.PureComponent<Props> {
	render() {
		const { children, icon, schema, size, form, disabled, className, testId } =
			this.props

		const { validating = false, submitting = false } = form || {}

		return (
			<Button
				type="submit"
				className={className}
				disabled={disabled || validating || submitting}
				isLoading={submitting}
				icon={icon}
				schema={schema}
				size={size}
				testId={testId}
			>
				{children}
			</Button>
		)
	}
}

export default withForm(Submit) as typeof Submit
